"use client";

import { useTournamentStore } from "./tournament-store";
import type { TournamentStatus } from "./types";

/**
 * Турнир отыгран — данные по нему больше не меняются.
 *
 * KAN-935: единственный потребитель — выключение опроса там, где опрашивать
 * нечего (сетка завершённого турнира весит 24,6 КБ и до правки качалась каждые
 * 15 секунд на вкладке «Итоги»).
 *
 * Ответ берётся из уже загруженного объекта турнира в сторе: своего запроса
 * хук не делает — иначе экономия одного опроса стоила бы нового запроса.
 * Если турнир в сторе не тот или ещё не загружен, ответ `false`: опрос
 * останется, и это безопасная сторона ошибки.
 */
/** Конечные статусы: после них турнир не меняется (KAN-1181). Легаси-строчные включены. */
const FINISHED_STATUSES: ReadonlySet<string> = new Set<TournamentStatus>([
  "Completed",
  "Cancelled",
  "completed",
  "cancelled",
]);

export function isFinishedTournamentStatus(
  status: string | null | undefined,
): boolean {
  return status != null && FINISHED_STATUSES.has(status);
}

export function useIsTournamentFinished(tournamentId?: string): boolean {
  return useTournamentStore((state) => {
    const t = state.currentTournament;
    if (!t) return false;
    if (tournamentId && t.id !== tournamentId && t.slug !== tournamentId) {
      return false;
    }
    return (
      isFinishedTournamentStatus(t.backendStatus) ||
      isFinishedTournamentStatus(t.status)
    );
  });
}
